import React, { useState, useEffect } from "react";
import GalleryService from "../../services/GalleryService";

const AddGallery = () => {
  const initialGalleryState = {
    id: null,
    name: "",
    image: null,
    published: false,
  };
  const [gallery, setGallery] = useState(initialGalleryState);
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState("");
  //const [alert, setAlert] = useState("alert alert-danger");
  // const [image, setImage] = useState(null);

  // console.log(Gallery)

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGallery({ ...gallery, [name]: value });
  };

  const handleImageInputChange = (e) => {
    const { name } = e.target;
    const inputimage = e.target.files[0];
    // setImage(inputimage);
    setGallery({ ...gallery, [name]: inputimage });
  };

  const saveGallery = () => {
    var data = {
      name: gallery.name,
      image: gallery.image,
    };
    console.log(data);
    GalleryService.create(data)
      .then((response) => {
        setGallery({
          id: response.data.id,
          name: response.data.name,
          image: response.data.image,
          published: response.data.published,
        });
        setSubmitted(true);
        setServermessage("Successfully Added Item " + response.data.name);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e.response.data.message);
        setServermessage("Upps! " + e.response.data.message);
      });
  };

  const newGallery = () => {
    setGallery(initialGalleryState);
    setSubmitted(false);
  };

  useEffect(() => {}, []);

  // console.log("Gallery Data:"+JSON.stringify(gallery))
  return (
    <div className="container pb-10">
      <h1 className="text-1xl lg:text-1xl font-semibold py-10">
        {" "}
        Add Gallery Media
      </h1>
      <div>
        {submitted ? (
          <div
            className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
            role="alert"
          >
            <p style={{ marginBottom: "0" }}>{servermessage}</p>
          </div>
        ) : (
          <>
            {servermessage ? (
              <p className="text-clay-500 px-4 py-3 rounded relative bg-red-100 border border-red-700">
                {servermessage}
              </p>
            ) : (
              ""
            )}
          </>
        )}
        <br></br>
      </div>

      <form className="w-full">
        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/3">
            <label
              className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
              htmlFor="inline-full-name"
            >
              Name
            </label>
          </div>
          <div className="md:w-2/3">
            <input
              className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
              id="name"
              name="name"
              type="text"
              value={gallery.name}
              required
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="md:flex md:items-center mb-6">
          <div className="md:w-1/3">
            <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
              Image
            </label>
          </div>
          <div className="md:w-2/3">
            <input
              className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
              type="file"
              id="image"
              onChange={handleImageInputChange}
              name="image"
            />
          </div>
        </div>
      </form>

      <div className="md:flex md:items-center">
        <div className="md:w-1/3"></div>
        <div className="md:w-2/3 grid grid-cols-2 gap-40">
          {submitted ? (
            <div>
              {/* <div className={alert} role="alert">
          {servermessage}
</div> */}

              <button
                className="shadow bg-green-800 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="submit"
                onClick={newGallery}
              >
                Add New
              </button>
            </div>
          ) : (
            <>
              <button
                className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="submit"
                onClick={saveGallery}
              >
                Submit
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default AddGallery;
